import { render, staticRenderFns } from "./scenicAreaEstimatePeople.vue?vue&type=template&id=2fd3978a&scoped=true"
import script from "./scenicAreaEstimatePeople.vue?vue&type=script&lang=js"
export * from "./scenicAreaEstimatePeople.vue?vue&type=script&lang=js"
import style0 from "./scenicAreaEstimatePeople.vue?vue&type=style&index=0&id=2fd3978a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3978a",
  null
  
)

export default component.exports